import I18n from 'I18n';
import styled from 'styled-components';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Link } from 'foundations-components/transitional/components/Link';
// @ts-expect-error untyped module
import KnowledgeBaseButton from 'ui-addon-i18n/components/KnowledgeBaseButton';
import { invoiceOnFileChargeValidationMessageSubCategories } from '../../api/validationsAPI';
// @ts-expect-error untyped module
import formatCurrencyName from 'I18n/utils/formatCurrencyName';
import { INVOICE_VALIDATION_ERRORS } from '../../constants/paymentMethodOnFile';
import { CHARGE_PAYMENT_METHOD_SOURCE } from './ChargePaymentMethodTooltip';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledDiv = styled.div.withConfig({
  displayName: "ChargePaymentMethodTooltipMessage__StyledDiv",
  componentId: "sc-10wj3gl-0"
})(() => {
  return {
    display: 'block'
  };
});
const StyledDivWithMargin = styled(StyledDiv)(({
  theme: _theme
}) => {
  const theme = _theme;
  return {
    marginTop: theme.space['400'],
    marginBottom: theme.space['400']
  };
});
const ChargePaymentMethodTooltipMessage = ({
  onClick,
  onFileValidation,
  invoiceValidation,
  source
}) => {
  if (invoiceValidation === INVOICE_VALIDATION_ERRORS.INVALID_DUE_DATE) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "invoices.components.invoiceActionsDropdown.tooltips.chargePaymentMethod.invalidDueDate"
    });
  } else if (invoiceValidation === INVOICE_VALIDATION_ERRORS.MISSING_CONTACT) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "invoices.components.invoiceActionsDropdown.tooltips.chargePaymentMethod.missingContact"
    });
  } else if (invoiceValidation === INVOICE_VALIDATION_ERRORS.NOT_PAYMENTS_ACTIVATED) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "invoices.components.invoiceActionsDropdown.tooltips.chargePaymentMethod.notPaymentsActivated"
    });
  } else if (!onFileValidation) {
    return null;
  }
  switch (onFileValidation.subCategory) {
    case invoiceOnFileChargeValidationMessageSubCategories.PARTIAL_PAYMENTS:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "invoices.components.invoiceActionsDropdown.tooltips.chargePaymentMethod.partialPayments"
      });
    case invoiceOnFileChargeValidationMessageSubCategories.PMOF_IS_NOT_CHARGEABLE:
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(StyledDivWithMargin, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "invoices.components.invoiceActionsDropdown.tooltips.chargePaymentMethod.popover.description"
          })
        }), /*#__PURE__*/_jsx(StyledDiv, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "invoices.components.invoiceActionsDropdown.tooltips.chargePaymentMethod.popover.nextStep"
          })
        })]
      });
    case invoiceOnFileChargeValidationMessageSubCategories.NO_ACTIVE_PMOF_FOR_CONTACT:
      return /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "invoices.components.invoiceActionsDropdown.tooltips.chargePaymentMethod.atLeastOneContact_jsx",
        elements: {
          KnowledgeBaseButton
        },
        options: {
          url: 'https://knowledge.hubspot.com/payments/store-a-payment-method-for-future-charges/',
          use: 'tertiary',
          className: 'p-y-0 p-x-0',
          external: true
        }
      });
    case invoiceOnFileChargeValidationMessageSubCategories.MIN_TOTAL_NOT_REACHED:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "invoices.components.invoiceActionsDropdown.tooltips.chargePaymentMethod.totalBelowLimitGeneric"
      });
    case invoiceOnFileChargeValidationMessageSubCategories.MAX_TOTAL_EXCEEDED:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "invoices.components.invoiceActionsDropdown.tooltips.chargePaymentMethod.limitExceededGeneric"
      });
    case invoiceOnFileChargeValidationMessageSubCategories.INVALID_SESSION_CURRENCY_CODE:
      return source === CHARGE_PAYMENT_METHOD_SOURCE.EDITOR ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "invoices.components.invoiceActionsDropdown.tooltips.chargePaymentMethod.incompatibleCurrencyInEditor"
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "invoices.components.invoiceActionsDropdown.tooltips.chargePaymentMethod.incompatibleCurrency",
        options: {
          currencies: I18n.formatList(onFileValidation.context.validCurrencyCodes.map(currency => formatCurrencyName(currency)))
        }
      });
    case invoiceOnFileChargeValidationMessageSubCategories.NO_EMAIL_ADDRESS_FOR_CONTACT:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "invoices.components.invoiceActionsDropdown.tooltips.chargePaymentMethod.noEmail"
      });
    case invoiceOnFileChargeValidationMessageSubCategories.INVALID_NUMBER_OF_ASSOCIATIONS:
      return onClick && source !== CHARGE_PAYMENT_METHOD_SOURCE.EDITOR ? /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "invoices.components.invoiceActionsDropdown.tooltips.chargePaymentMethod.moreThanOneBillableContact_jsx",
        elements: {
          UILink: Link
        },
        options: {
          onClick
        }
      }) : /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "invoices.components.invoiceActionsDropdown.tooltips.chargePaymentMethod.moreThanOneBillableContactNoEdit"
      });
    case invoiceOnFileChargeValidationMessageSubCategories.ASSOCIATION_CHANGED:
      return onClick && source !== CHARGE_PAYMENT_METHOD_SOURCE.EDITOR ? /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "invoices.components.invoiceActionsDropdown.tooltips.chargePaymentMethod.associationChanged_jsx",
        elements: {
          UILink: Link
        },
        options: {
          onClick
        }
      }) : /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "invoices.components.invoiceActionsDropdown.tooltips.chargePaymentMethod.associationChangedNoEdit"
      });
    case invoiceOnFileChargeValidationMessageSubCategories.CANNOT_CREATE_CHECKOUT_SESSION_WITH_COLLECTION_METHOD:
      return onClick && source !== CHARGE_PAYMENT_METHOD_SOURCE.EDITOR ? /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "invoices.components.invoiceActionsDropdown.tooltips.chargePaymentMethod.invalidCollectionMethod_jsx",
        elements: {
          UILink: Link
        },
        options: {
          onClick
        }
      }) : /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "invoices.components.invoiceActionsDropdown.tooltips.chargePaymentMethod.invalidCollectionMethodNoEdit"
      });
    default:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "invoices.components.invoiceActionsDropdown.tooltips.chargePaymentMethod.unknownError"
      });
  }
};
export default ChargePaymentMethodTooltipMessage;